import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, TicketIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
type Show = {
  day: string;
  month: string;
  venue: string;
  address: string;
  featured?: boolean;
  ticketUrl?: string;
  tag?: string;
};
const shows: Show[] = [{
  day: '22',
  month: 'MAY',
  venue: 'Rest Los Cabos',
  address: '2252 E Irlo Bronson Memorial Hwy, Kissimmee, FL 34744'
}, {
  day: '28',
  month: 'MAY',
  venue: 'Blue Martini',
  address: '9101 International Dr #1182, Orlando, FL 32819'
}, {
  day: '25',
  month: 'JUN',
  venue: 'Blue Martini',
  address: '9101 International Dr #1182, Orlando, FL 32819'
}, {
  day: '15',
  month: 'AUG',
  venue: 'Selena Tribute — Como La Flor',
  address: 'Live Show · Tickets via Ticketplate',
  featured: true,
  tag: 'TRIBUTO',
  ticketUrl: 'https://ticketplate.com/checkout/como-la-flor-selena-tribute-2608151900'
}];
export function Shows() {
  const {
    t
  } = useLanguage();
  return <section id="shows" className="py-24 md:py-32 bg-ink2" data-id="element-185">
      <div className="max-w-5xl mx-auto px-6 lg:px-10" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 flex items-end justify-between flex-wrap gap-4" data-id="element-187">
          <div data-id="element-188">
            <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-189">
              {t('shows.eyebrow')}
            </p>
            <h2 className="font-display text-4xl md:text-5xl text-cream leading-tight" data-id="element-190">
              {t('shows.title.1')}{' '}
              <span className="italic gold-text" data-id="element-191">{t('shows.title.2')}</span>
            </h2>
          </div>
          <p className="text-cream/50 text-sm" data-id="element-192">{t('shows.subtitle')}</p>
        </motion.div>

        <div className="border-t border-gold/15" data-id="element-193">
          {shows.map((s, i) => {
          const RowTag = s.ticketUrl ? 'a' : 'div';
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} data-id="element-194">
                <RowTag {...s.ticketUrl ? {
              href: s.ticketUrl,
              target: '_blank',
              rel: 'noopener noreferrer'
            } : {}} className={`group flex items-center gap-5 md:gap-10 py-6 border-b border-gold/15 hover:bg-gold/5 transition-colors px-2 ${s.featured ? 'bg-gold/[0.04]' : ''}`} data-id="element-195">
                  {/* Date */}
                  <div className="flex flex-col items-center w-14 md:w-24 shrink-0" data-id="element-196">
                    <div className="font-display text-3xl md:text-5xl gold-text leading-none" data-id="element-197">
                      {s.day}
                    </div>
                    <div className="text-[10px] md:text-xs tracking-[0.25em] text-cream/50 group-hover:text-gold transition-colors mt-1 md:mt-2" data-id="element-198">
                      {s.month}
                    </div>
                  </div>

                  {/* Venue + address */}
                  <div className="flex-1 min-w-0" data-id="element-199">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-200">
                      <div className="font-display text-lg md:text-2xl text-cream group-hover:text-gold-light transition-colors" data-id="element-201">
                        {s.venue}
                      </div>
                      {s.tag && <span className="text-[10px] tracking-[0.2em] px-2 py-1 rounded-full bg-gold text-ink font-medium" data-id="element-202">
                          {s.tag}
                        </span>}
                    </div>
                    <div className="text-cream/50 text-xs md:text-sm flex items-start gap-1.5 mt-1.5" data-id="element-203">
                      <MapPinIcon size={12} className="mt-0.5 shrink-0" data-id="element-204" />
                      <span data-id="element-205">{s.address}</span>
                    </div>
                  </div>

                  {/* CTA */}
                  {s.ticketUrl && <div className="hidden md:inline-flex items-center gap-1.5 text-gold text-xs tracking-[0.2em] uppercase shrink-0 group-hover:text-gold-light transition-colors" data-id="element-206">
                      <TicketIcon size={14} data-id="element-207" />
                      Tickets
                    </div>}
                </RowTag>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}